<template>
  <v-card class="card" color="primary">
    <v-card-text>
      <v-container>
        <v-row>
          <v-col align="right">
            <TextButton @click="openRegistrarNuevaLicencia"> REGISTRAR LICENCIA </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="locs" class="transparent">
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-card-account-details-outline"
                              @click="openVerDetalleLicencia(item)"
                            />
                          </span>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton variant="secondary" icon="mdi-pencil" @click="openEditarLicencia(item)" />
                          </span>
                        </template>
                        <span>Editar Licencia</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'
import IconButton from '@src/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: {
    TextButton,
    IconButton,
  },
  data() {
    return {
      headers: [
        { text: 'Numero de Oficio', value: 'numeroOficio', width: '10%' },
        { text: 'Numero de Licencia', value: 'noLicencia', width: '10%' },
        { text: 'Representante legal', value: 'representanteLegal', width: '10%' },
        { text: 'Titular', value: 'titular', width: '10%' },
        { text: 'Vigencia', value: 'vigencia', width: '10%' },
        { text: 'Fecha de alta', value: 'fechaAlta', width: '10%' },
        { text: 'Fecha de tramite', value: 'fechaTramite', width: '10%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
      loading: false,
      DIALOG_TYPES,
    }
  },
  computed: {
    ...mapGetters('licenciaOficialColectiva', {
      locsOriginal: 'getLocs',
    }),
    ...mapGetters('remesas', {
      remesas: 'getRemesas',
    }),
    locs() {
      return this.locsOriginal.map((loc) => ({
        ...loc,
        fechaAlta: loc.fechaAlta
          ? moment(loc.fechaAlta, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).isValid()
            ? moment(loc.fechaAlta, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
            : 'Fecha inválida'
          : '',
        fechaTramite: loc.fechaTramite
          ? moment(loc.fechaTramite, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).isValid()
            ? moment(loc.fechaTramite, ['M/D/YYYY', 'M/DD/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
            : 'Fecha inválida'
          : '',
      }))
    },
  },
  methods: {
    ...mapActions('licenciaOficialColectiva', {
      fetchLocs: 'fetchLocs',
    }),
    ...mapActions('remesas', {
      fetchRemesas: 'fetchRemesas',
    }),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('licenciaOficialColectiva', ['SET_SELECTED_LOC']),
    ...mapMutations('remesas', ['SET_SELECTED_REMESA']),

    openRegistrarNuevaLicencia() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRAR_NUEVA_LICENCIA_OFICIAL_COLECTIVA)
    },
    openVerDetalleLicencia(licenciaOficialColectiva) {
      this.SET_SELECTED_LOC(licenciaOficialColectiva)
      this.SET_DIALOG(DIALOG_TYPES.MOSTRAR_DETALLE_LICENCIA_OFICIAL_COLECTIVA)
    },
    openEditarLicencia(licenciaOficialColectiva) {
      this.SET_SELECTED_LOC(licenciaOficialColectiva)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_LICENCIA_OFICIAL_COLECTIVA)
    },
  },
  created() {
    this.fetchLocs()
    this.fetchRemesas()
  },
}
</script>
